module.exports = function() {
  return new Worker(__webpack_public_path__ + "61380454b6fd321257af.worker.js");
};